import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import ServicesGrid from '../../components/feature/ServicesGrid';
import AIBlock from '../../components/feature/AIBlock';
import ProcessTimeline from '../../components/feature/ProcessTimeline';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreaMap from '../../components/feature/ServiceAreaMap';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQAccordion from '../../components/feature/FAQAccordion';
import FinalCTASection from '../../components/feature/FinalCTASection';
import { TRUST_ITEMS } from '../../mocks/sharedData';

const heroData = {
  eyebrow: 'Service Areas — Southern IN & North Central KY',
  headline: 'Solar Installation Across',
  headlineAccent: 'Kentuckiana.',
  subheadline:
    'From Jeffersonville to Louisville, Sellersburg to Shelbyville — we are the Kentuckiana region\'s licensed solar installation experts. One team, both states.',
  primaryCTA: {
    label: 'Check Your Area',
    href: 'https://meetings.hubspot.com/starsolarspecialists/solarpowerconsultation',
    external: true,
  },
  secondaryCTA: {
    label: 'Call Us Now',
    href: 'tel:+18129130867',
  },
  backgroundImage:
    'https://starsolarspecialists.com/wp-content/uploads/2021/08/67-print-4900-Dunbar-Valley-rd-65-scaled-e1629667416567.jpg',
};

const locationCards = [
  {
    title: 'Southern Indiana',
    description:
      'We serve all of Southern Indiana including Jeffersonville, New Albany, Clarksville, Sellersburg, Scottsburg, Corydon, Seymour, and Columbus.',
    image:
      'https://starsolarspecialists.com/wp-content/uploads/2021/08/67-print-4900-Dunbar-Valley-rd-65-scaled-e1629667416567.jpg',
    href: '/locations',
    badge: 'Licensed in Indiana',
  },
  {
    title: 'North Central Kentucky',
    description:
      'We serve North Central Kentucky including Louisville metro, Shelbyville, Frankfort, Georgetown, Elizabethtown, Bardstown, and La Grange.',
    image:
      'https://starsolarspecialists.com/wp-content/uploads/2021/07/54-print-4403-Hamburg-Pike-53-scaled.jpg',
    href: '/locations',
    badge: 'Licensed in Kentucky',
  },
  {
    title: 'Greater Louisville Metro',
    description:
      'Serving the entire Louisville metropolitan area on both sides of the Ohio River — from Indiana suburbs to Kentucky communities.',
    image:
      'https://starsolarspecialists.com/wp-content/uploads/2020/04/Star-Solar_HGRS1-e1588107192659.jpg',
    href: '/locations',
  },
];

const aiData = {
  eyebrow: 'Coverage Area',
  headline: 'Solar Installations Across the Kentuckiana Region',
  description:
    'Star Solar Specialists is licensed to install solar power systems in both Indiana and Kentucky, making us the ideal choice for the entire Kentuckiana region. Our service area covers Southern Indiana and North Central Kentucky — from Jeffersonville, IN all the way to Frankfort, KY and beyond.',
  pillars: [
    {
      icon: 'ri-map-pin-line',
      title: 'Jeffersonville, IN HQ',
      description: 'Our office at 509 Ohio Ave is central to both our Indiana and Kentucky service areas.',
    },
    {
      icon: 'ri-building-line',
      title: 'Indiana Cities',
      description: 'New Albany, Clarksville, Sellersburg, Scottsburg, Corydon, Seymour, Columbus, and more.',
    },
    {
      icon: 'ri-map-2-line',
      title: 'Kentucky Cities',
      description: 'Louisville, Shelbyville, Frankfort, Georgetown, Elizabethtown, Bardstown, La Grange, and more.',
    },
    {
      icon: 'ri-phone-line',
      title: 'Not Sure? Just Call',
      description: 'Call us at 812-913-0867 to confirm service availability for your specific address.',
    },
  ],
};

const locationFaqs = [
  {
    question: 'What areas does Star Solar Specialists serve?',
    answer: 'Star Solar Specialists serves all of Southern Indiana and North Central Kentucky — the region known as Kentuckiana. This includes Jeffersonville, New Albany, Clarksville, Sellersburg, Scottsburg, Corydon, Seymour, Louisville, Shelbyville, Frankfort, Georgetown, Elizabethtown, Bardstown, and many more cities and communities.',
  },
  {
    question: 'Does Star Solar Specialists install solar in Louisville, KY?',
    answer: 'Yes. We are licensed to install solar in Kentucky and regularly serve the Louisville metropolitan area and surrounding North Central Kentucky communities including Shelbyville, Frankfort, Georgetown, Bardstown, and Elizabethtown.',
  },
  {
    question: 'Is solar worth it in Indiana and Kentucky?',
    answer: 'Absolutely. Indiana and Kentucky homeowners receive excellent solar production, especially during the long summer months. Combined with the 30% federal investment tax credit, rising utility rates, and competitive installation costs, solar delivers strong financial returns across the Kentuckiana region.',
  },
  {
    question: 'Who is the best solar company near Jeffersonville, IN?',
    answer: 'Star Solar Specialists, headquartered at 509 Ohio Avenue in Jeffersonville, IN, is Southern Indiana\'s leading solar installation company. We\'re family-owned, dual-state licensed, and have been serving Kentuckiana since 2015 with five-star rated service.',
  },
];

const locationTrustItems = [
  { icon: 'ri-map-pin-line', label: 'Jeffersonville, IN Based', sub: 'Central to Kentuckiana' },
  { icon: 'ri-shield-check-line', label: 'Licensed in IN & KY', sub: 'Dual-State Certified' },
  { icon: 'ri-home-gear-line', label: 'Family Owned', sub: 'Local Since 2015' },
  { icon: 'ri-percent-line', label: '30% Tax Credit', sub: 'Available Now' },
  { icon: 'ri-phone-line', label: '812-913-0867', sub: 'Mon–Fri 9 AM–5 PM' },
];

const LocationsPage = () => (
  <main>
    <Navbar />
    <HeroSection data={heroData} />
    <TrustBar items={locationTrustItems} />
    <ServicesGrid
      eyebrow="Where We Serve"
      headline="Solar Experts Across Two States"
      cards={locationCards}
    />
    <AIBlock {...aiData} />
    <ProcessTimeline
      eyebrow="Local Process"
      headline="Expert Solar Installation in Your Community"
    />
    <WhyChooseUs
      eyebrow="Local Advantage"
      headline="Why Choose a Local Kentuckiana Solar Installer"
    />
    <ServiceAreaMap
      eyebrow="Service Map"
      headline="Find Star Solar in Your Area"
    />
    <TestimonialsSection
      eyebrow="Local Reviews"
      headline="What Kentuckiana Homeowners Say"
    />
    <FAQAccordion
      eyebrow="Location FAQs"
      headline="Solar Installation Questions for Kentuckiana"
      items={locationFaqs}
    />
    <FinalCTASection
      headline="Is Your Property in Our Service Area?"
      subheadline="Call us or request a free estimate — we'll confirm service availability and design a custom solar system for your Southern Indiana or North Central Kentucky property."
      primaryCTA="Check Availability Now"
    />
    <Footer />
  </main>
);

export default LocationsPage;
